import { DeliveryOrderListPage } from "@/features/delivery-order/pages/DeliveryOrderListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/delivery-order/")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["delivery_order.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: DeliveryOrderListPage,
});
